import React, { useState } from 'react'

import { FormControl, FormHelperText, Stack, Collapse, Typography } from '@mui/material'
import { TextField as UiTextField, Button } from '@repo/ui'

import type { FieldValues } from 'react-hook-form'

import { FieldProps } from './types'

const FieldImpl = ({
  label,
  name,
  placeholder,
  startAdornment,
  endAdornment,
  rules,
  register,
  helperText,
  formState: { errors },
  readOnly = false,
  defaultValue = '',
  type = 'text',
  onSave,
}: FieldProps) => {
  const [internalValue, setInternalValue] = useState(defaultValue)

  // useEffect(() => {
  //   if (defaultValue !== undefined) {
  //     setInternalValue(defaultValue)
  //   }
  // }, [defaultValue])

  // TODO: combine fields so that they all inheirt this base Field with ability to save directly or not as prop: saveable. Like we did with Previews component. see children placeholder below
  return (
    <FormControl error={!!errors[name]} fullWidth>
      <Stack spacing={2}>
        <Stack direction="row" spacing={3}>
          {label && (
            <Typography variant="body3">
              {label}
            </Typography>
          )}
          {helperText && <FormHelperText>({helperText})</FormHelperText>}
        </Stack>
        {/* children */}
        <UiTextField
          type={type}
          placeholder={placeholder}
          startAdornment={startAdornment}
          endAdornment={endAdornment}
          disabled={readOnly}
          // The visible label above is a bare Typography, so name the control itself.
          inputProps={label ? { 'aria-label': label } : undefined}
          defaultValue={defaultValue}
          error={!!errors[name]}
          onValueChange={(value) => setInternalValue(value)}
          {...register(name, rules)}
        />
        {onSave && (
          <Collapse in={internalValue != defaultValue}>
            <Stack direction="row" spacing={3} pt={1}>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setInternalValue(defaultValue)
                    // TODO: Tre, handle the cancel button action to set input back to defualt value and I think we want this entire FILE to become a prop option on TextField and have Field be the container like on Filters
                  }}>
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    onSave(internalValue)
                  }}>
                  Save
                </Button>
            </Stack>
          </Collapse> 
        )}
        {errors[name] && <FormHelperText sx={{ margin: '4px 0 0' }}>{errors[name]?.message as string}</FormHelperText>}
      </Stack>
    </FormControl>
  )
}

/**
 * Re-exported under the generic signature so a caller's own form type flows through.
 * See the `FieldProps` docblock in `./types` for why the implementation above stays on the
 * default instantiation and why this assertion is the standard idiom rather than a
 * suppression.
 */
export const Field = FieldImpl as <T extends FieldValues = FieldValues>(
  props: FieldProps<T>,
) => React.ReactElement | null
